// External dependencies
import { Button, ColorIndicator, GradientPicker } from "@wordpress/components";

export default (userOptions) => {
    const getAttr = (attribute) => {
        const store = userOptions.props.attributes;
        return !!store[attribute] ? store[attribute] : "";
    };

    const attribute = getAttr(userOptions.attribute);
    /* eslint-disable-next-line */
    const defaultValue = "linear-gradient(, rgba(6, 147, 227, 1) 0%, rgb(155, 81, 224) 100%)";
    /* eslint-disable-next-line */
    const verifiedValue = attribute !== undefined && attribute !== "" ? attribute : "";

    const toggleOpen = () =>
        userOptions.props.updateAttributes({
            customToggles: {
                ...userOptions.props.attributes.customToggles,
                /* eslint-disable-next-line */
                [userOptions.attribute]: !userOptions.props.attributes.customToggles[userOptions.attribute],
            },
        });

    return (
        <>
            <Button
                variant="tertiary"
                label={userOptions.labelText}
                showTooltip={true}
                onClick={toggleOpen}
                style={{ flexDirection: "column-reverse", height: "60px", gap: "8px", alignItems: "flex-start" }}
            >
                <ColorIndicator colorValue={verifiedValue} />
                <span style={{ color: "#1B2559" }}>{userOptions.labelText}</span>
            </Button>
            {userOptions.props.attributes.customToggles[userOptions.attribute] && (
                <GradientPicker
                    gradients={[]}
                    value={verifiedValue !== "" ? verifiedValue : undefined}
                    onChange={(value) =>
                        userOptions.props.updateAttributes({
                            [userOptions.attribute]: value,
                        })
                    }
                />
            )}
        </>
    );
};
